import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/movies';

export default function LatestUpdates() {
  const displayMovies = latestUpdates.slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">
              最新上线的精彩内容
            </p>
          </div>
          <Link
            to="/category/tv-series"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
          {displayMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0 w-24 md:w-28 overflow-hidden rounded-lg">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ aspectRatio: '2/3' }}
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-primary-100 text-primary-600 text-xs rounded-md whitespace-nowrap">
                      {movie.category}
                    </span>
                    {movie.isNew && (
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-600 text-xs rounded-md whitespace-nowrap">
                        最新
                      </span>
                    )}
                  </div>
                  <h3 className="text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                    {movie.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                    {movie.description}
                  </p>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-400"></i>
                      {movie.rating}
                    </span>
                    <span>{movie.year}</span>
                  </div>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                    {movie.updateEpisode}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}